import React from "react";

// Editorial section divider with chapter numeral + meta label.
export const SectionDivider = ({ index = "01", label, dark = false }) => {
  const c = dark ? "text-bone" : "text-ink";
  const sub = dark ? "text-bone/60" : "text-char-mute";
  const rule = dark ? "bg-bone/15" : "bg-ink/15";
  return (
    <div data-testid="section-divider" className={`flex items-end gap-6 md:gap-10 ${c}`}>
      <span className="editorial-num text-5xl md:text-7xl leading-none opacity-90">
        {index}
      </span>
      <div className="flex-1 pb-3 md:pb-4">
        <div className={`h-px w-full ${rule}`} />
        <p className={`mt-3 font-mono text-[10px] uppercase tracking-wider3 ${sub}`}>
          {label}
        </p>
      </div>
    </div>
  );
};

export default SectionDivider;
